import * as React from "react";
import { observer } from "mobx-react";

@observer
export class EventDate extends React.Component<{ date: string }, {}> {

    render() {
        return (
            <span data-uat="span-multiview-date" className="rj-sports-multiview__event-date">{this.props.date}</span>
        )
    }
}